import React from 'react';
// import './List.css';
import ListItem from './ListItem';
import { setListComponent, dateSelected, filterDataByDate, filterData } from './filter.js';
import { hasFilter } from './FilterTasks';

export function getTasks() {
    // console.log("get tasks");
    var tasks = JSON.parse(localStorage.getItem('tasks'));
    if (tasks == null) {
        tasks = [];
    }
    // sort tasks by date (ascending), if selected move to bottom
    tasks.sort(function (a, b) {
        if (a.selected) {
            return 1;
        } else if (b.selected) {
            return -1;
        } else {
            return new Date(a.date) - new Date(b.date);
        }
    });
    // console.log(tasks);
    return tasks;
}

export function sortList(list) {
    // console.log("sort list");
    // sort tasks by date (ascending), if selected move to bottom
    list.sort(function (a, b) {
        if (a.selected) {
            return 1;
        } else if (b.selected) {
            return -1;
        } else if (a.date == b.date) {
            // convert from 12 hour to 24 hour time
            var time = a.time.split(" ");
            var hour = time[0].split(":")[0];
            var minute = time[0].split(":")[1];
            var ampm = time[1];
            if (ampm == "PM") {
                hour = parseInt(hour) + 12;
            }
            var atime = hour + ":" + minute;
            time = b.time.split(" ");
            hour = time[0].split(":")[0];
            minute = time[0].split(":")[1];
            ampm = time[1];
            if (ampm == "PM") {
                hour = parseInt(hour) + 12;
            }
            var btime = hour + ":" + minute;
            return new Date("1970/01/01 " + atime) - new Date("1970/01/01 " + btime);
        }
        else {
            return new Date(a.date) - new Date(b.date);
        }
    });
    // console.log(list);
    return list;
}

function getExistingList() {
    // console.log("get existing list");
    var tasks = getTasks();
    var listItems = [];
    for (var i = 0; i < tasks.length; i++) {
        var task = tasks[i];
        // convert task date to format like "Feb 1"
        var date = new Date(task.date + "T00:00:00");
        var month = date.toLocaleString('default', { month: 'short' });
        var day = date.getDate();
        task.date = month + " " + day;
        listItems.push(task);
    }
    return listItems;
}

class List extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: getExistingList(),
            class: this.props.class,
            render: false
        }
        setListComponent(this);
    }

    getFilteredTasks = () => {
        // console.log("get filtered tasks");
        // console.log("flkjskjhfsdhjklsfdkjhlsfdjklsfdkl" + dateSelected());
        if (hasFilter()) {
            // console.log("has filter");
            return sortList(filterData());
        }
        else if (dateSelected()) {
            // console.log("date selected");
            return sortList(filterDataByDate());
        } else {
            return sortList(getExistingList());
        }
    }

    getListItems = () => {
        // console.log("get list items");
        var list = this.getFilteredTasks();
        if (list.length == 0) {
            return <div className="empty-list">No tasks to show</div>;
        }
        var listItems = [];
        for (var i = 0; i < list.length; i++) {
            var task = list[i];
            listItems.push(
                <ListItem
                    title={task.name}
                    date={task.date}
                    time={task.time}
                    location={task.location}
                    description={task.description}
                    id={task.id}
                    selected={task.selected}
                    reRender={this.reRender}
                    key = {task.id}
                    category = {task.category}
                    categoryColor = {task.categoryColor}
                />
            );
        }
        return listItems;
    }

    reRender = () => {
        // remove the list items and re-render
        this.setState({
            render: false
        }, () => {
            this.setState({
                render: true
            });
        });
    }

    render() {
        return (
            <div className='list'>
                {this.getListItems()}
            </div>
        );
    }
}
export default List;